module.exports = __webpack_public_path__ + "media/images/request-success-f0c94f70.svg";